import { useState, useContext } from 'react'
import { ThemeContext } from '../Context'
import AccountInfos from './AccountInfos'
import AccountAccess from './AccountAccess'
import AccountSettings from './AccountSettings'
import AccountLanguage from './AccountLanguage'
import AccountDataInfo from './AccountDataInfo'
import Insertions from './Insertions'
import Statistics from './Statistics'
import MyRubrics from './MyRubrics'
import { 
   Box, 
   Paper, 
   List, 
   ListItemButton, 
   ListItemText,
   ListItemIcon,
   Container,
   Grid
} from '@mui/material'
import { 
   AccountCircle, 
   Palette, 
   Lock, 
   Language, 
   BookmarkAdd,
   BarChart,
   LibraryBooks,
   Storage
} from '@mui/icons-material'

function Account() {
   const { theme } = useContext(ThemeContext)
   const [activeTab, setActiveTab] = useState('statistics')

   const isDark = theme === 'dark'

   const menuItems = [
      { id: 'statistics', label: 'Statistiques', icon: BarChart },
      { id: 'infos', label: 'Informations du compte', icon: AccountCircle },
      { id: 'settings', label: 'Couleur de mon nom', icon: Palette },
      { id: 'access', label: 'Modifier mon mot de passe', icon: Lock },
      { id: 'language', label: 'Langue de l\'interface', icon: Language },
      { id: 'datainfo', label: 'Conservation des données', icon: Storage },
      { id: 'insertions', label: 'Gérer mes insertions', icon: BookmarkAdd },
      { id: 'rubrics', label: 'Gérer mes rubriques', icon: LibraryBooks }
   ]

   const renderContent = () => {
      switch (activeTab) {
         case 'statistics':
            return <Statistics />
         case 'infos':
            return <AccountInfos />
         case 'settings':
            return <AccountSettings />
         case 'access':
            return <AccountAccess />
         case 'language':
            return <AccountLanguage />
         case 'datainfo':
            return <AccountDataInfo />
         case 'insertions':
            return <Insertions />
         case 'rubrics':
            return <MyRubrics />
         default:
            return <Statistics />
      }
   }

   return (
      <Box sx={{ maxWidth: 1400, mx: 'auto', mt: 3, mb: 3, px: 2 }}>
         <Grid container spacing={1.5} alignItems="flex-start">
            {/* Menu de navigation à gauche */}
            <Grid item xs={12} md={3}>
               <Paper
                  elevation={2}
                  sx={{
                     position: { md: 'sticky' },
                     top: { md: 'calc(6.5vh + 20px)' },
                     borderRadius: 2,
                     bgcolor: isDark ? '#233044' : '#ffffff',
                     color: isDark ? '#fff' : 'inherit',
                     boxShadow: isDark 
                        ? '0 4px 20px rgba(0, 0, 0, 0.5)'
                        : '0 4px 20px rgba(0,0,0,0.05)',
                  }}
               >
                  <List component="nav" sx={{ p: 1 }}>
                     {menuItems.map((item) => {
                        const Icon = item.icon
                        return (
                           <ListItemButton
                              key={item.id}
                              selected={activeTab === item.id}
                              onClick={() => setActiveTab(item.id)}
                              sx={{
                                 borderRadius: 1,
                                 mb: 0.5,
                                 '&.Mui-selected': {
                                    bgcolor: isDark 
                                       ? 'rgba(144, 202, 249, 0.15)' 
                                       : 'rgba(25, 118, 210, 0.08)',
                                    '&:hover': {
                                       bgcolor: isDark 
                                          ? 'rgba(144, 202, 249, 0.25)' 
                                          : 'rgba(25, 118, 210, 0.12)',
                                    }
                                 },
                                 '&:hover': {
                                    bgcolor: isDark 
                                       ? 'rgba(144, 202, 249, 0.08)' 
                                       : 'rgba(0, 0, 0, 0.04)',
                                 }
                              }}
                           >
                              <ListItemIcon
                                 sx={{
                                    minWidth: 40,
                                    color: activeTab === item.id
                                       ? (isDark ? '#90caf9' : '#1976d2')
                                       : (isDark ? '#b0bec5' : 'inherit'),
                                 }}
                              >
                                 <Icon />
                              </ListItemIcon>
                              <ListItemText 
                                 primary={item.label}
                                 sx={{
                                    '& .MuiListItemText-primary': {
                                       color: activeTab === item.id
                                          ? (isDark ? '#90caf9' : '#1976d2')
                                          : (isDark ? '#fff' : 'inherit'),
                                       fontWeight: activeTab === item.id ? 600 : 400,
                                       fontSize: '0.95rem',
                                    }
                                 }}
                              />
                           </ListItemButton>
                        )
                     })}
                  </List>
               </Paper>
            </Grid>

            {/* Contenu principal */}
            <Grid item xs={12} md={9}>
               <Box sx={{ mt: { xs: 0, md: 0 } }}>
                  {renderContent()}
               </Box>
            </Grid>
         </Grid>
      </Box>
   )
}

export default Account